import { t } from "@lingui/macro";
import React from "react";

import { HoleCountIcon } from "@whoosh/design-system/src/components/icons_v2/courseLayout";
import type { HoleCount } from "@whoosh/design-system/src/components/icons_v2/courseLayout/icons/HoleCountIcon";
import { TeeSheetTransportationIcon } from "@whoosh/design-system/src/components/icons_v2/transportation";
import type { TransportationCode } from "@whoosh/design-system/src/components/icons_v2/transportation/icons/TeeSheetTransportationIcon";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

export type EventCardPairingBookingProps = {
  playerName: string;
  courseLayout: HoleCount;
  transportationType: TransportationCode;
  isYou?: boolean;
  isYourBooking?: boolean;
};

export const EventCardPairingBooking = ({
  playerName,
  courseLayout,
  transportationType,
  isYou = false,
  isYourBooking,
}: EventCardPairingBookingProps) => {
  return (
    <HStack gap={1} alignItems="center">
      <Box p={1} borderRadius="2" backgroundColor="surface-secondary">
        <HStack
          gap={1}
          backgroundColor={"grayscale-200"}
          padding={1}
          borderRadius="2"
        >
          <TeeSheetTransportationIcon transportationType={transportationType} />
          <HoleCountIcon holeCount={courseLayout} />
        </HStack>
      </Box>
      <Text
        variant="mainSmall"
        numberOfLines={1}
        testID={`event-card-pairings-booking-player-${playerName.toLowerCase()}`}
        color={isYourBooking ? "text-primary" : "text-secondary"}
      >
        {playerName}
        {isYou ? t` (You)` : ""}
      </Text>
    </HStack>
  );
};
